import IMG1 from '../../assets/portfolio1.png'
import IMG3 from '../../assets/portfolio3.png'
import IMG4 from '../../assets/portfolio4.png'
import IMG7 from '../../assets/portfolio7.png'
import IMG8 from '../../assets/portfolio8.png'
import IMG9 from '../../assets/portfolio9.png'


const projectrs = [
    {
        "name":"Tap2Deliver",
        "desc":"food delivery app with user app, restaurant app, rider app and admin dashboard as site.",
        "fontColor":"#4db5ff",
        "sourceUrl":[
            "https://github.com/sayanbiswascoder/Tap2Deliver",
            "https://github.com/sayanbiswascoder/Tap2DeliverRestaurant",
            "https://github.com/sayanbiswascoder/Tap2DeliverRider",
            "https://github.com/sayanbiswascoder/Tap2DeliverBackend"
        ],
        "url":"",
        "imgUrl":IMG9
    },
    {
        "name":"CensorFlow",
        "desc":"It's an AI-powered content moderation tool designed to identify sensitive visual content.",
        "fontColor":"white",
        "sourceUrl":[
            "https://github.com/sayanbiswascoder/CensorFlow"
        ],
        "url":"",
        "imgUrl":IMG7
    },
    {
        "name":"VoteChain",
        "desc":"VoteChain is a decentralized voting application built on the Sepolia Testnet using Next.js",
        "fontColor":"white",
        "sourceUrl":[
            "https://github.com/sayanbiswascoder/VoteChain"
        ],
        "url":"https://vote-chain-lime.vercel.app/",
        "imgUrl":IMG8
    },
    {
        "name":"candyhub",
        "desc": "This is a fully functional E-Comerce site.",
        "fontColor":"white",
        "sourceUrl": ["https://github.com/sayanbiswascoder/candyhub"],
        "url":"https://candyhub.vercel.app",
        "imgUrl":IMG1
    },
    {
        "name":"AnonChat",
        "desc": "Here you can chat with random parsom who are using the webapp at the same time.",
        "fontColor":"white",
        "sourceUrl": [
            "https://github.com/sayanbiswascoder/AnonChat"
        ],
        "url":"https://anonchat-seven.vercel.app/",
        "imgUrl":IMG3
    },
    {
        "name":"Sudoku Solver",
        "desc": "Online Sudoku Solver.",
        "fontColor":"white",
        "sourceUrl": ["https://github.com/sayanbiswascoder/sudoku-solver"],
        "url":"https://sudoku-solver-bysb.vercel.app",
        "imgUrl":IMG4
    }
]

export default projectrs;